import React from "react";
import Modal from "../../components/common/modal";
import Button from "../../components/common/button";
import Toggle from "../../components/common/toggle";
import { useFormik } from "formik";
import { getTagValidationSchema } from "../../validation/tagValidation";

const toBool = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const s = value.trim().toLowerCase();
    if (["true", "1", "active", "enabled", "yes"].includes(s)) return true;
    if (["false", "0", "inactive", "disabled", "no"].includes(s)) return false;
  }
  return false;
};

const emptyValues = {
  name: "",
  slug: "",
  isActive: true,
};

const TagModal = ({
  isOpen,
  onClose,
  tag,
  mode = "create",
  onSave,
  isLoading = false,
}) => {
  const isEditing = mode === "edit";
  const isDelete = mode === "delete";

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: tag
      ? {
          name: tag.name || tag.title || "",
          slug: tag.slug || "",
          isActive: toBool(
            typeof tag.isActive !== "undefined"
              ? tag.isActive
              : tag.status === "Active" || tag.isactive === true,
          ),
        }
      : emptyValues,
    validationSchema: getTagValidationSchema(),
    onSubmit: (values) => {
      onSave(values);
    },
  });

  const handleSave = () => {
    formik.setTouched({ name: true, slug: true });
    formik.handleSubmit();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        isDelete
          ? "Delete Tag"
          : mode === "view"
            ? "View Tag"
            : isEditing
              ? "Edit Tag"
              : "Add New Tag"
      }
    >
      {isDelete ? (
        <>
          <div style={{ padding: "10px 2px" }}>
            <p style={{ margin: 0, color: "#333" }}>
              Are you sure you want to delete{" "}
              <strong>{tag?.name || tag?.title || "this tag"}</strong>?
            </p>
            <p style={{ margin: "8px 0 0", color: "#666", fontSize: 13 }}>
              This action will remove it from the database.
            </p>
          </div>

          <div className="modal-footer">
            <Button className="CancelButton" onClick={onClose}>
              Cancel
            </Button>
            <Button
              className="CommonButton"
              onClick={() => onSave?.()}
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </>
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <div className="form-group">
            <label>Tag Name</label>
            <input
              type="text"
              name="name"
              placeholder="Tag Name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={mode === "view"}
            />
            {formik.touched.name && formik.errors.name && (
              <p className="error-text">{formik.errors.name}</p>
            )}
          </div>

          <div className="form-group">
            <label>Tag Slug</label>
            <input
              type="text"
              name="slug"
              placeholder="Tag Slug"
              value={formik.values.slug}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={mode === "view"}
            />
            {formik.touched.slug && formik.errors.slug && (
              <p className="error-text">{formik.errors.slug}</p>
            )}
          </div>

          <div
            className="form-group"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: 30,
            }}
          >
            <label>Status</label>
            <div className="sharing-toggle">
              <Toggle
                onChange={(checked) => formik.setFieldValue("isActive", checked)}
                checked={!!formik.values.isActive}
                disabled={mode === "view"}
              />
            </div>
          </div>

          <div className="modal-footer">
            <Button
              type="button"
              className="CancelButton"
              onClick={onClose}
            >
              {mode === "view" ? "Close" : "Cancel"}
            </Button>
            {mode !== "view" && (
              <Button
                type="button"
                className="CommonButton"
                onClick={handleSave}
                disabled={isLoading}
              >
                {isLoading
                  ? "Saving..."
                  : isEditing
                    ? "Save Changes"
                    : "Add Tag"}
              </Button>
            )}
          </div>
        </form>
      )}
    </Modal>
  );
};

export default TagModal;
